import * as React from "react";

import { usePirschClient } from "./usePirschClient";

export const PirschPageviewTracker = ({ location }) => {
  const pirschClient = usePirschClient();

  React.useEffect(() => {
    if (!pirschClient || !location) {
      return;
    }

    pirschClient.hit().catch(() => {
      // silently ignore these errors, as they are not critical to the application
    });
  }, [location, pirschClient]);

  return null;
};
